export default __webpack_public_path__ + "static/media/ic_spinner.be0fe050.svg";